
import makerjs from "makerjs";
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;
  
  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
      x: midX + h * ux,
      y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;
  
  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);
  
  return {
      x: center.x + sumX * invLen,
      y: center.y + sumY * invLen
  };
}
function B61(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,S1 = Param[3].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       r = R * 1 * myZoom,      
       l = L * 1 * myZoom,       
       s1 = S1 * 1 * myZoom,       
       h = l,
       w = b,
       //hd=r-l,
       
       x0 = 0, x1 = 0, x2 =b/2 ,x3 =b ,x4 =b , 
       y0 = 0, y1 =r,y2 =l, y3 =r, y4 =0,glassH =h, glassW = w;
       // 示例用法
const start = { x: x1, y: y1 };
const end = { x: x2, y: y2 };
const radius = s1;
// const midpoint = calculateArcMidpoint(start, end, radius);
const midpoint =optimizedArcMidpoint(start, end, radius);
console.log("输出劣弧中点坐标start=",start); // 输出劣弧中点坐标
console.log("输出劣弧中点坐标end=",end); // 输出劣弧中点坐标
console.log("输出劣弧中点坐标=",midpoint); // 输出劣弧中点坐标
      //  var aa=Circle_Center(x1,y1,x2,y2,r);
      //  console.log("aa====",aa);
      var xm=midpoint.x,ym=midpoint.y;
      
console.log("输出劣弧中点坐标xm,ym=",xm,ym); // 输出劣弧中点坐标
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
      var TxtL = "L="+L;
    }if (r !== 0) {
      var TxtR = "R="+R;
    }if (s1 !== 0) {
      var TxtS1 = "S1="+S1;
    }
   var drawAbnormalShapeB61 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftArcLine": new makerjs.paths.Arc([x1, y1], [x2,y2], s1,false,true),
        "RightArcLine": new makerjs.paths.Arc([x2, y2], [x3,y3], s1,false,true),
        "TopLine": new makerjs.paths.Line([x3,y3], [x4,y4]),
        "BottomLine": new makerjs.paths.Line([x4,y4],[0, 0]),
       }
   };
   var drawAbnormalShapeB61MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB61MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, l]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, l], [x1- 2 * markShift, l]),
       }
   };
   var drawAbnormalShapeB61MarkS1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([xm, ym], [xm+b/3, ym-b/3]),
        // "UpShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
        // "UpShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
   };
   var drawAbnormalShapeB61MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x3+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB61MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB61MarkL, TxtL,  [x0- 2*markShift, y0], [x1- 2*markShift, l]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB61MarkR, TxtR,  [x4+ 2*markShift, y4], [x3+ 2*markShift, y3]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB61MarkS1, TxtS1, [xm+b/3, ym-b/3-markShift], [xm+b/3+3*markShift, ym-b/3-markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB61: drawAbnormalShapeB61,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB61: drawAbnormalShapeB61,
        drawAbnormalShapeB61MarkB:drawAbnormalShapeB61MarkB,
        drawAbnormalShapeB61MarkL:drawAbnormalShapeB61MarkL,
        drawAbnormalShapeB61MarkR:drawAbnormalShapeB61MarkR,
        drawAbnormalShapeB61MarkS1:drawAbnormalShapeB61MarkS1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B61;